module.exports = __webpack_public_path__ + "assets/img/lx_w_d_i_4.3a563264.jpg";